module.exports = __webpack_public_path__ + "img/中国足球发展基金会@2x.d90499ea.png";